import { useRef, useEffect, forwardRef, useImperativeHandle, memo, useState } from 'react';
import styles from './FJAudioWaveImg.module.less';
import FJMessageStore from '../../../store/FJMessageStore.js';
import FJLocalStore from '../../../store/FJLocalStore.js';
import FJUtil from '../../../util/FJUtil.js';
import classNames from 'classnames';
import PropTypes from 'prop-types';
let f_timeID = null;

const FJAudioWaveImgUpload = (props, ref) => {
    const { url, setIsPlay, updateDuration, recordPlay = () => {}, isPlay, config } = props;

    useImperativeHandle(ref, () => ({
        play: () => {
            play();
        },
        pause: () => {
            pause();
        },
    }));

    const [audioWaveImgUrl, setAudioWaveImgUrl] = useState(null);
    const [audioWavePlayImgUrl, setAudioWavePlayImgUrl] = useState(null);

    const isLoadedRef = useRef(false);
    const isErrorRef = useRef(false);
    const audioRef = useRef(null);
    const progressRef = useRef(false);
    const isSeekingRef = useRef(false);
    const seekProgress = useRef(0);
    const duration = useRef(0);
    const [audioUrl, setAudioUrl] = useState(url);
    const [audioProgress, setAudioProgress] = useState(0);
    const [cursorProgress, setCursorProgress] = useState(0);

    useEffect(() => {
        setAudioProgress(0);
        setCursorProgress(0);
        duration.current = 0;
        seekProgress.current = 0;
        const __func = async () => {
            const imgUrl = await FJUtil.getAudioWave(url, false, config);
            const hoverImgUrl = await FJUtil.getAudioWave(url, true, config);
            setAudioWaveImgUrl(imgUrl);
            setAudioWavePlayImgUrl(hoverImgUrl);
        };
        __func();
    }, [url]);

    useEffect(() => {
        setAudioUrl(url);
    }, [url]);

    useEffect(() => {
        isLoadedRef.current = false;
        isErrorRef.current = false;
    }, [audioUrl]);

    const play = () => {
        if (isErrorRef.current && isLoadedRef.current) {
            isLoadedRef.current = false;
            isErrorRef.current = false;
            setAudioUrl(FJUtil.getReloadNewUrl(url));
        } else {
            if (audioRef.current) {
                audioRef.current.play();
            }
        }
    };

    const pause = () => {
        if (audioRef.current) {
            audioRef.current.pause();
        }
        if (f_timeID) clearInterval(f_timeID);
    };

    const onClick = e => {
        e.stopPropagation();
        // setIsPlay(true);
        // audioRef.current.play();
        // recordPlay();
    };

    const onMouseDown = e => {
        e.stopPropagation();
    };

    const _onEnded = () => {
        if (f_timeID) clearInterval(f_timeID);
        setIsPlay(false);
        setAudioProgress(0);
    };

    const _onError = e => {
        console.log('_onError::', e);
        isErrorRef.current = true;
        isLoadedRef.current = true;
        setIsPlay(false);
        if (isPlay) {
            FJMessageStore.addMessage(FJLocalStore._('playback-failed-please-try-again'), 'error');
        }
    };

    const _onLoadedData = () => {
        isLoadedRef.current = true;
        isErrorRef.current = false;
        duration.current = audioRef.current.duration;
        updateDuration(audioRef.current.duration);
        if (isPlay) {
            audioRef.current.play();
        }
    };

    const _onLoadStart = () => {
        isLoadedRef.current = false;
        isErrorRef.current = false;
    };

    const _onPlaying = () => {
        if (f_timeID) clearInterval(f_timeID);
        f_timeID = setInterval(() => {
            setAudioProgress(
                duration.current === 0 ? 1 : audioRef.current ? audioRef.current.currentTime / duration.current : 0,
            );
        }, 16.7);
    };

    const _getProgressByCursor = e => {
        let { width, left } = progressRef.current.getBoundingClientRect();
        let value = (e.clientX - left) / width;
        return FJUtil.getValueInRange(value, 0, 1);
    };
    const _mouseDown = e => {
        isSeekingRef.current = true;
        setIsPlay(false);
        pause();
        const progress = _getProgressByCursor(e);
        _seek(progress);
        seekProgress.current = progress;
        FJUtil.addEvent(progressRef.current, 'mousemove', _mouseMove);
        FJUtil.addEvent(document.body, 'mouseup', _mouseUp);
    };

    const _mouseMove = e => {
        if (isSeekingRef.current) {
            const progress = _getProgressByCursor(e);
            _seek(progress);
            seekProgress.current = progress;
        }
    };

    const _mouseUp = () => {
        isSeekingRef.current = false;
        if (duration.current) {
            let time = seekProgress.current * duration.current;
            if (isFinite(time)) {
                audioRef.current.currentTime = time;
            }

            setIsPlay(true);
            play();
            recordPlay();
        }
        FJUtil.removeEvent(progressRef.current, 'mousemove', _mouseMove);
        FJUtil.removeEvent(document.body, 'mouseup', _mouseUp);
    };

    const _mouseMoveForOver = e => {
        setCursorProgress(_getProgressByCursor(e));
    };

    const _seek = progress => {
        setAudioProgress(progress);
        setCursorProgress(progress);
    };

    const playProgress = audioProgress * 100 + '%';

    return (
        <div className={styles.box} onClick={onClick} onMouseDown={onMouseDown}>
            <div
                className={styles.img_box}
                style={{ display: audioWaveImgUrl && audioWavePlayImgUrl ? 'block' : 'none' }}
            >
                <img className={classNames(styles.img)} src={audioWaveImgUrl} alt='' />
                <img
                    className={classNames(styles.img)}
                    src={audioWavePlayImgUrl}
                    style={{
                        clipPath: `polygon(0 0, ${playProgress} 0, ${playProgress} 100%, 0 100%)`,
                    }}
                    alt=''
                />
            </div>
            <div
                onMouseDown={_mouseDown}
                onMouseMove={_mouseMoveForOver}
                ref={progressRef}
                className={styles.audio_progress}
            >
                <i
                    style={{
                        left: cursorProgress * 100 + '%',
                        display: audioWaveImgUrl && audioWavePlayImgUrl ? 'block' : 'none',
                    }}
                    className={styles.audio_cursor}
                />
            </div>
            <audio
                src={audioUrl}
                ref={audioRef}
                onEnded={_onEnded}
                onError={_onError}
                onLoadedData={_onLoadedData}
                onLoadStart={_onLoadStart}
                onPlaying={_onPlaying}
            />
        </div>
    );
};

FJAudioWaveImgUpload.propTypes = {
    url: PropTypes.string,
    setIsPlay: PropTypes.func,
    updateDuration: PropTypes.func,
    recordPlay: PropTypes.func,
    isPlay: PropTypes.bool,
};

export default memo(forwardRef(FJAudioWaveImgUpload));
